<template>
	<v-dialog v-model="showDialog" max-width="600" scrollable>
		<v-card>
			<v-toolbar color="primary" dark flat>
				<v-toolbar-title>Paper Citation Details</v-toolbar-title>
				<v-spacer />
				<v-btn icon @click="closeDialog">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text v-if="!hasCitationData" class="pa-5 text-center text-fg-2">
				No citation information available for this paper.
			</v-card-text>

			<v-card-text v-else class="pa-5">
				<div
					v-for="field in visibleFields"
					:key="field.label"
					class="citation-field"
				>
					<div class="field-label">
						{{ field.label }}
					</div>
					<div class="field-value">
						{{ field.value }}
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "DataEntryPaperCitationDialog",

	props: {
		modelValue: Boolean,
		paper: {
			type: Object,
			default: () => null,
		},
	},
	emits: ["update:modelValue"],

	computed: {
		showDialog: {
			get() {
				return this.modelValue;
			},
			set(newValue) {
				this.$emit("update:modelValue", newValue);
			},
		},

		allFields() {
			if (!this.paper) return [];
			return [
				{ label: "Paper Name", value: this.paper.name },
				{ label: "DOI", value: this.paper.doi },
				{ label: "PubMed ID", value: this.paper.pmid },
				{ label: "PubMed Central ID", value: this.paper.pmcid },
				{ label: "Source URL", value: this.paper.source_url },
				{
					label: "Publication Title",
					value: this.paper.publication_title,
				},
				{ label: "Short Title", value: this.paper.short_title },
				{
					label: "Journal Abbreviation",
					value: this.paper.journal_abbreviation,
				},
				{ label: "ISSN", value: this.paper.issn },
				{ label: "Volume", value: this.paper.volume },
				{ label: "Issue", value: this.paper.issue },
				{ label: "Pages", value: this.paper.pages },
				{ label: "Item Type", value: this.paper.item_type },
				{
					label: "Publication Date",
					value: this.paper.publication_date,
				},
				{ label: "Authors", value: this.creatorsDisplay },
				{ label: "MeSH Tags", value: this.citationTagsDisplay },
				{ label: "Abstract", value: this.paper.abstract_note },
			];
		},

		visibleFields() {
			return this.allFields.filter(
				(f) => f.value !== null && f.value !== undefined && f.value !== "",
			);
		},

		hasCitationData() {
			return this.visibleFields.length > 0;
		},

		creatorsDisplay() {
			const creators = this.paper?.creators;
			if (!creators || !creators.length) return null;
			return creators
				.filter((c) => c.creatorType === "author")
				.map((a) => a.name || `${a.firstName} ${a.lastName}`)
				.join(", ");
		},

		citationTagsDisplay() {
			const tags = this.paper?.citation_tags;
			if (!tags || !tags.length) return null;
			return tags.map((t) => t.tag).join(", ");
		},
	},

	methods: {
		closeDialog() {
			this.showDialog = false;
		},
	},
};
</script>

<style scoped lang="scss">
.citation-field {
	padding: 8px 0;
	border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);

	&:last-child {
		border-bottom: none;
	}
}
.field-label {
	font-size: 0.75rem;
	font-weight: 600;
	color: rgba(var(--v-theme-on-surface), 0.5);
	margin-bottom: 2px;
}
.field-value {
	font-size: 0.925rem;
	line-height: 1.4;
}
</style>
